import axios, { ENDPOINTS } from 'src/utils/axios';
import { TelegramTokenResponse } from 'src/types';

export const getTelegramToken = async () => {
  const response = await axios.get<TelegramTokenResponse>(ENDPOINTS.tg.token);
  return response.data;
};
